module.exports = __webpack_public_path__ + "static/media/serge-work-sample.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designer-profiles/serge-work-sample.png
// module id = 525
// module chunks = 0